import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Taxonomy} from './taxonomy.reducer';
import {environment} from '../../environments/environment';
import {apiVersionHeader} from '../segment/segments-client.service';
import {ApiVersion} from '../app.types';
import {CreateUpdateTaxonomy} from './taxonomy-facade.service';
import {TaxonomyFilterModel} from './taxonomy-filters/taxonomy-filters.component';

@Injectable({
  providedIn: 'root'
})
export class TaxonomyClientService {

  constructor(private http: HttpClient) {
  }

  getAll(): Observable<Taxonomy[]> {
    return this.http.get<Taxonomy[]>(`${environment.apiSegments}/taxonomy/`, apiVersionHeader(ApiVersion.V2));
  }

  getByFilter(filter: TaxonomyFilterModel): Observable<Taxonomy[]> {
    return this.http.post<Taxonomy[]>(`${environment.apiSegments}/taxonomy/filtered`, filter, apiVersionHeader(ApiVersion.V2));
  }

  getById(id: number): Observable<Taxonomy> {
    return this.http.get<Taxonomy>(`${environment.apiSegments}/taxonomy/${id}`, apiVersionHeader(ApiVersion.V2));
  }

  create(body: CreateUpdateTaxonomy): Observable<Taxonomy> {
    return this.http.post<Taxonomy>(`${environment.apiSegments}/taxonomy/`, body, apiVersionHeader(ApiVersion.V2));
  }

  update(body: CreateUpdateTaxonomy, id: number): Observable<Taxonomy> {
    return this.http.put<Taxonomy>(`${environment.apiSegments}/taxonomy/${id}`, body, apiVersionHeader(ApiVersion.V2));
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiSegments}/taxonomy/${id}`, apiVersionHeader(ApiVersion.V2));
  }
}
